module.exports = __webpack_public_path__ + "static/media/icon-feather-send.582b6632.svg";